import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import verificandoToken from '../../FuncoesGerais/VerificarToken';
import { fetchOpcoes, fetchAutomacoes, createAutomacao, updateAutomacao, deleteAutomacao, fetchExecucoes, parseJSON } from '../../api/automacoes';
import { fetchAnalistas } from '../../api/usuarios';
import './Automacoes.css';

const REGRA_INICIAL = { id: null, nome: '', evento: 'chamado_criado', condicoes: [], acoes: [], ativo: true };

function formatarDataHora(d) {
    if (!d) return '';
    const dt = new Date(d);
    return Number.isNaN(dt.getTime()) ? '' : dt.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

function Automacoes() {
    const history = useHistory();
    const [opcoes, setOpcoes] = useState({ eventos: [], campos: [], operadores: [], acoes: [] });
    const [analistas, setAnalistas] = useState([]);
    const [regras, setRegras] = useState([]);
    const [loading, setLoading] = useState(true);
    const [mensagem, setMensagem] = useState('');

    const [show, setShow] = useState(false);
    const [regra, setRegra] = useState(REGRA_INICIAL);
    const [salvando, setSalvando] = useState(false);

    const [drawer, setDrawer] = useState(null);
    const [execucoes, setExecucoes] = useState([]);

    const verificar = useCallback(async () => {
        const ok = await verificandoApp('ATENDENTE');
        if (!ok) history.push('/');
    }, [history]);

    const carregar = useCallback(async () => {
        verificandoToken();
        setLoading(true);
        try { setRegras(await fetchAutomacoes()); } finally { setLoading(false); }
    }, []);

    useEffect(() => {
        verificar();
        carregar();
        fetchOpcoes().then((o) => o && setOpcoes(o));
        fetchAnalistas().then((l) => setAnalistas(Array.isArray(l) ? l : []));
    }, [verificar, carregar]);

    const eventoLabel = (k) => (opcoes.eventos.find((e) => e.key === k)?.label) || k;
    const acaoLabel = (k) => (opcoes.acoes.find((a) => a.key === k)?.label) || k;

    const abrirNova = () => { setRegra(REGRA_INICIAL); setMensagem(''); setShow(true); };
    const abrirEdicao = (r) => {
        setRegra({
            id: r.id, nome: r.nome, evento: r.evento, ativo: r.ativo !== 0,
            condicoes: parseJSON(r.condicoes, []) || [], acoes: parseJSON(r.acoes, []) || [],
        });
        setMensagem('');
        setShow(true);
    };

    const addCondicao = () => setRegra((s) => ({ ...s, condicoes: [...s.condicoes, { campo: 'tipo_id', operador: 'igual', valor: '' }] }));
    const setCondicao = (i, patch) => setRegra((s) => ({ ...s, condicoes: s.condicoes.map((c, idx) => idx === i ? { ...c, ...patch } : c) }));
    const delCondicao = (i) => setRegra((s) => ({ ...s, condicoes: s.condicoes.filter((_, idx) => idx !== i) }));

    const addAcao = () => setRegra((s) => ({ ...s, acoes: [...s.acoes, { tipo: 'notificar', alvo: 'responsavel', titulo: '', mensagem: '' }] }));
    const setAcao = (i, patch) => setRegra((s) => ({ ...s, acoes: s.acoes.map((a, idx) => idx === i ? { ...a, ...patch } : a) }));
    const delAcao = (i) => setRegra((s) => ({ ...s, acoes: s.acoes.filter((_, idx) => idx !== i) }));

    const salvar = async () => {
        if (!regra.nome.trim()) { setMensagem('Informe o nome da regra.'); return; }
        if (regra.acoes.length === 0) { setMensagem('Adicione ao menos uma ação.'); return; }
        setSalvando(true);
        setMensagem('');
        try {
            const body = { nome: regra.nome.trim(), evento: regra.evento, condicoes: regra.condicoes, acoes: regra.acoes, ativo: regra.ativo };
            if (regra.id) await updateAutomacao(regra.id, body);
            else await createAutomacao(body);
            setShow(false);
            await carregar();
        } catch (e) {
            setMensagem(e?.response?.data?.error || 'Erro ao salvar regra.');
        } finally { setSalvando(false); }
    };

    const alternarAtivo = async (r) => {
        try { await updateAutomacao(r.id, { ativo: r.ativo ? false : true }); await carregar(); }
        catch (e) { setMensagem(e?.response?.data?.error || 'Erro ao alterar.'); }
    };
    const remover = async (r) => {
        if (!window.confirm(`Excluir a regra "${r.nome}"?`)) return;
        try { await deleteAutomacao(r.id); await carregar(); }
        catch (e) { setMensagem(e?.response?.data?.error || 'Erro ao excluir.'); }
    };
    const abrirLog = async (r) => { setDrawer(r); setExecucoes(await fetchExecucoes(r.id)); };

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="container-fluid titulo cadastro-unificado auto-page">
                    <div className="page-header d-flex flex-wrap justify-content-between align-items-center gap-2">
                        <div>
                            <h1 className="mb-0"><i className="fas fa-bolt me-2" />Automações</h1>
                            <p className="text-muted small mb-0">Regras "quando acontece X → então faça Y".</p>
                        </div>
                        <button type="button" className="btn btn-primary btn-sm" onClick={abrirNova}><i className="fas fa-plus me-1" />Nova regra</button>
                    </div>

                    {mensagem && !show && <div className="alert alert-danger py-2 my-2">{mensagem}</div>}
                    {loading && <p className="text-muted">Carregando...</p>}
                    {!loading && regras.length === 0 && <div className="alert alert-info py-3 mt-3">Nenhuma regra ainda. Clique em "Nova regra".</div>}

                    {!loading && regras.length > 0 && (
                        <div className="row g-3 mt-1">
                            {regras.map((r) => {
                                const conds = parseJSON(r.condicoes, []) || [];
                                const acoes = parseJSON(r.acoes, []) || [];
                                return (
                                    <div key={r.id} className="col-12 col-lg-6">
                                        <div className={`card auto-card h-100 ${r.ativo ? '' : 'auto-card-off'}`}>
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between align-items-start mb-1">
                                                    <h5 className="mb-0 auto-card-nome">{r.nome}</h5>
                                                    <span className={`badge ${r.ativo ? 'bg-success' : 'bg-secondary'}`}>{r.ativo ? 'Ativa' : 'Inativa'}</span>
                                                </div>
                                                <div className="auto-evento small mb-2"><i className="fas fa-bolt me-1" />{eventoLabel(r.evento)}</div>
                                                <div className="small text-muted mb-1">
                                                    {conds.length === 0 ? 'Sem condições (sempre)' : `${conds.length} condição(ões)`} ·{' '}
                                                    {acoes.map((a) => acaoLabel(a.tipo)).join(', ') || 'sem ações'}
                                                </div>
                                                <div className="small text-muted">{r.total_execucoes || 0} execução(ões)</div>
                                                <div className="auto-card-acoes mt-2 d-flex gap-1">
                                                    <button className="btn btn-sm btn-outline-primary" onClick={() => abrirEdicao(r)}><i className="fas fa-pen me-1" />Editar</button>
                                                    <button className="btn btn-sm btn-outline-secondary" onClick={() => abrirLog(r)}><i className="fas fa-history me-1" />Log</button>
                                                    <button className="btn btn-sm btn-outline-secondary" onClick={() => alternarAtivo(r)}>{r.ativo ? 'Desativar' : 'Ativar'}</button>
                                                    <button className="btn btn-sm btn-outline-danger ms-auto" onClick={() => remover(r)}><i className="fas fa-trash" /></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </main>

            {show && (
                <div className="modal-overlay" onClick={() => !salvando && setShow(false)}>
                    <div className="modal-card auto-modal" onClick={(e) => e.stopPropagation()}>
                        <h5 className="mb-3"><i className="fas fa-bolt me-2" />{regra.id ? 'Editar regra' : 'Nova regra'}</h5>

                        <div className="form-group mb-2">
                            <label className="small">Nome</label>
                            <input className="form-control form-control-sm" value={regra.nome} onChange={(e) => setRegra({ ...regra, nome: e.target.value })} placeholder="Ex.: Roteia Web Services para o time X" />
                        </div>
                        <div className="form-group mb-3">
                            <label className="small"><i className="fas fa-bolt me-1" />Quando (evento)</label>
                            <select className="form-control form-control-sm" value={regra.evento} onChange={(e) => setRegra({ ...regra, evento: e.target.value })}>
                                {opcoes.eventos.map((e) => <option key={e.key} value={e.key}>{e.label}</option>)}
                            </select>
                        </div>

                        <div className="auto-secao mb-3">
                            <div className="auto-secao-titulo d-flex justify-content-between align-items-center">
                                <span><i className="fas fa-filter me-1" />Condições (todas precisam passar)</span>
                                <button className="btn btn-sm btn-outline-primary" onClick={addCondicao}><i className="fas fa-plus" /></button>
                            </div>
                            {regra.condicoes.length === 0 && <div className="text-muted small py-1">Sem condições = a regra sempre dispara.</div>}
                            {regra.condicoes.map((c, i) => (
                                <div key={i} className="auto-linha d-flex gap-1 align-items-center mb-1">
                                    <select className="form-control form-control-sm" value={c.campo} onChange={(e) => setCondicao(i, { campo: e.target.value })}>
                                        {opcoes.campos.map((cp) => <option key={cp.key} value={cp.key}>{cp.label}</option>)}
                                    </select>
                                    <select className="form-control form-control-sm" style={{ maxWidth: 140 }} value={c.operador} onChange={(e) => setCondicao(i, { operador: e.target.value })}>
                                        {opcoes.operadores.map((op) => <option key={op.key} value={op.key}>{op.label}</option>)}
                                    </select>
                                    <input className="form-control form-control-sm" value={c.valor} onChange={(e) => setCondicao(i, { valor: e.target.value })} placeholder="valor" />
                                    <button className="btn btn-sm btn-link text-danger p-1" onClick={() => delCondicao(i)}><i className="fas fa-times" /></button>
                                </div>
                            ))}
                        </div>

                        <div className="auto-secao mb-2">
                            <div className="auto-secao-titulo d-flex justify-content-between align-items-center">
                                <span><i className="fas fa-play me-1" />Então (ações)</span>
                                <button className="btn btn-sm btn-outline-primary" onClick={addAcao}><i className="fas fa-plus" /></button>
                            </div>
                            {regra.acoes.length === 0 && <div className="text-muted small py-1">Adicione ao menos uma ação.</div>}
                            {regra.acoes.map((a, i) => (
                                <div key={i} className="auto-acao mb-2">
                                    <div className="d-flex gap-1 align-items-center mb-1">
                                        <select className="form-control form-control-sm" style={{ maxWidth: 200 }} value={a.tipo} onChange={(e) => setAcao(i, { tipo: e.target.value })}>
                                            {opcoes.acoes.map((ac) => <option key={ac.key} value={ac.key}>{ac.label}</option>)}
                                        </select>
                                        <button className="btn btn-sm btn-link text-danger p-1 ms-auto" onClick={() => delAcao(i)}><i className="fas fa-times" /></button>
                                    </div>
                                    <div className="auto-acao-params">
                                        {a.tipo === 'atribuir' && (
                                            <select className="form-control form-control-sm" value={a.usuario_id || ''} onChange={(e) => setAcao(i, { usuario_id: e.target.value })}>
                                                <option value="">Selecione o responsável...</option>
                                                {analistas.map((u) => <option key={u.USUSEQ ?? u.ususeq} value={u.USUSEQ ?? u.ususeq}>{u.USRNOMCPL ?? u.usrnomcpl ?? ('Usuário ' + (u.USUSEQ ?? u.ususeq))}</option>)}
                                            </select>
                                        )}
                                        {a.tipo === 'status' && (
                                            <input className="form-control form-control-sm" value={a.codigo || ''} onChange={(e) => setAcao(i, { codigo: e.target.value })} placeholder="Código do status (legado)" />
                                        )}
                                        {a.tipo === 'prioridade' && (
                                            <input className="form-control form-control-sm" value={a.valor || ''} onChange={(e) => setAcao(i, { valor: e.target.value })} placeholder="Prioridade (número)" />
                                        )}
                                        {a.tipo === 'notificar' && (
                                            <div className="d-flex flex-column gap-1">
                                                <select className="form-control form-control-sm" value={a.alvo || 'responsavel'} onChange={(e) => setAcao(i, { alvo: e.target.value })}>
                                                    <option value="responsavel">Notificar o responsável do chamado</option>
                                                    <option value="usuario">Notificar um usuário específico</option>
                                                </select>
                                                {a.alvo === 'usuario' && (
                                                    <select className="form-control form-control-sm" value={a.usuario_id || ''} onChange={(e) => setAcao(i, { usuario_id: e.target.value })}>
                                                        <option value="">Selecione o usuário...</option>
                                                        {analistas.map((u) => <option key={u.USUSEQ ?? u.ususeq} value={u.USUSEQ ?? u.ususeq}>{u.USRNOMCPL ?? u.usrnomcpl ?? ('Usuário ' + (u.USUSEQ ?? u.ususeq))}</option>)}
                                                    </select>
                                                )}
                                                <input className="form-control form-control-sm" value={a.titulo || ''} onChange={(e) => setAcao(i, { titulo: e.target.value })} placeholder="Título da notificação" />
                                                <input className="form-control form-control-sm" value={a.mensagem || ''} onChange={(e) => setAcao(i, { mensagem: e.target.value })} placeholder="Mensagem (opcional)" />
                                            </div>
                                        )}
                                        {a.tipo === 'comentar' && (
                                            <div className="d-flex flex-column gap-1">
                                                <input className="form-control form-control-sm" value={a.texto || ''} onChange={(e) => setAcao(i, { texto: e.target.value })} placeholder="Texto do comentário" />
                                                <label className="small"><input type="checkbox" checked={!!a.interno} onChange={(e) => setAcao(i, { interno: e.target.checked })} /> Comentário interno</label>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="form-check mb-2">
                            <input className="form-check-input" type="checkbox" id="auto-ativo" checked={regra.ativo} onChange={(e) => setRegra({ ...regra, ativo: e.target.checked })} />
                            <label className="form-check-label small" htmlFor="auto-ativo">Regra ativa</label>
                        </div>
                        {mensagem && <div className="alert alert-danger py-2 mb-2">{mensagem}</div>}
                        <div className="d-flex justify-content-end gap-2">
                            <button className="btn btn-secondary btn-sm" disabled={salvando} onClick={() => setShow(false)}>Cancelar</button>
                            <button className="btn btn-primary btn-sm" disabled={salvando} onClick={salvar}>{salvando ? 'Salvando...' : 'Salvar regra'}</button>
                        </div>
                    </div>
                </div>
            )}

            {drawer && (
                <div className="repo-drawer-overlay" onClick={() => setDrawer(null)}>
                    <div className="repo-drawer" onClick={(e) => e.stopPropagation()}>
                        <div className="repo-drawer-header">
                            <div>
                                <div className="repo-drawer-titulo"><i className="fas fa-history me-2" />{drawer.nome}</div>
                                <div className="small text-muted">Últimas execuções</div>
                            </div>
                            <button className="btn btn-sm btn-outline-secondary" onClick={() => setDrawer(null)}><i className="fas fa-times" /></button>
                        </div>
                        <div className="repo-drawer-body">
                            {execucoes.length === 0 && <p className="text-muted">Nenhuma execução registrada ainda.</p>}
                            {execucoes.map((e) => (
                                <div key={e.id} className="auto-exec-item">
                                    <div className="d-flex justify-content-between">
                                        <span className={e.sucesso ? 'text-success' : 'text-danger'}>
                                            <i className={`fas ${e.sucesso ? 'fa-check' : 'fa-triangle-exclamation'} me-1`} />
                                            {e.referencia ? `Chamado #${e.referencia}` : '—'}
                                        </span>
                                        <span className="small text-muted">{formatarDataHora(e.criado_em)}</span>
                                    </div>
                                    {e.detalhe && <div className="small text-muted">{e.detalhe}</div>}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Automacoes;
